import { useSelector } from "react-redux";
import Link from "next/link";
import styles from "./index.module.scss";

// Региональные папки /<город>/services/ есть только у этих городов
// (rewrites в next.config.js), остальным — ссылка на поддомен.
const CITIES_WITH_FOLDER = ["msk", "spb", "nn", "kirov"];

function buildCityHref(cityCode, mode) {
  if (mode === "relative" && CITIES_WITH_FOLDER.includes(cityCode)) {
    return `/${cityCode}/services/`;
  }
  return `https://${cityCode}.farkop.ru/services/`;
}

export default function ServicesNewEmpty({
  availableCities = [],
  mode = "absolute",
  variant = "default", // default | google
  isLanding = false,
}) {
  const { cityName } = useSelector((state) => state.location);

  return (
    <div className={styles.Empty}>
      {variant === "default" && (
        <h1>
          {cityName === "Россия" ? (
            <>Уважаемый клиент</>
          ) : (
            <>
              Уважаемый клиент, мы не оказываем услуги по установке и
              регистрации фаркопов и электрики в городе {cityName}
            </>
          )}
        </h1>
      )}

      <div>
        {/* eslint-disable-next-line no-nested-ternary */}
        {variant === "google" ? (
          <>
            Выберите ближайший к вам город для записи на установку или
            регистрации фаркопа:
          </>
        ) : cityName === "Россия" ? (
          <>
            Выберите ближайший к вам город для записи на установку или
            регистрации фаркопа:
          </>
        ) : (
          <>
            Мы работаем над открытием установочного центра в вашем городе, но вы
            можете выбрать ближайший к вам город для записи на установку или
            регистрации фаркопа:
          </>
        )}
      </div>

      <div className={styles.EmptyLinks}>
        {availableCities.map((city) => (
          <Link href={buildCityHref(city.code, mode)} key={city.code}>
            <a>{city.name}</a>
          </Link>
        ))}
      </div>

      {isLanding && (
        <div className={styles.Partner}>
          <div className={styles.PartnerText}>
            Установку осуществляет генеральный партнер
          </div>
          <a
            className={styles.PartnerLogo}
            href="https://farkop.ru"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/logo.svg" alt="Farkop.ru" />
          </a>
        </div>
      )}
    </div>
  );
}
